type DisplayPlayerNameSize = 'full' | 'sm' | 'md';

interface PlayerNameInput {
  firstName?: string;
  lastName?: string;
  name?: string;
  fullName?: string;
}

export const displayPlayerName = (
  player: PlayerNameInput,
  size: DisplayPlayerNameSize = 'full'
): string => {
  const first = player.firstName;
  const last = player.lastName;

  switch (size) {
    case 'sm':
      if (last) return last;
      if (player.name) return player.name;
      if (player.fullName) return player.fullName;
      return first || '';
    case 'md':
      if (first && last) return `${first.charAt(0)}. ${last}`;
      if (player.name) return player.name;
      if (player.fullName) return player.fullName;
      return last || first || '';
    default:
      if (first && last) return `${first} ${last}`;
      if (player.fullName) return player.fullName;
      if (player.name) return player.name;
      if (first) return first;
      if (last) return last;
      return '';
  }
};

export type { DisplayPlayerNameSize, PlayerNameInput };

